import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SegmentUtils from '../../utils/segment-utils';
import settings from '../../utils/settings';
import EntityFeedbackDialog from './EntityFeedbackDialog';
import GeneralFeedbackDialog from './GeneralFeedbackDialog';
import SegmentWithToolip from './SegmentWithTooltip';
import RelationshipsGraphDialog from './relationships/RelationshipsGraphDialog';
import RelationshipsTable from './relationships/RelationshipsTable';
import TranslatedTextDialog from './TranslatedTextDialog';
import Legend from './Legend';

const ConfidenceFilter = ({minConfidence, onConfidenceFilterChange, results, segments}) => {
    const min = SegmentUtils.minConfidence(results), max = 1.0, step = (max - min) / 25;

    const onChange = (ev) => {
        ev.preventDefault();
        var value = parseFloat(ev.currentTarget.value, 10);
        onConfidenceFilterChange(value);
    };

    return (
        <div>
            <label htmlFor="confidence-filter">Extraction Confidence: { minConfidence.toFixed(4) }</label>
            <input id="confidence-filter"
                type="range"
                className="confidence-slider"
                min={ min - step }
                max={ max }
                step={ step }
                value={ minConfidence }
                onChange={ onChange } />
        </div>
    );
};

class SegmentsControl extends Component {
    constructor(props) {
        super(props);
        this.handleFeedback = this.handleFeedback.bind(this);

        this.feedbackDisable = window._feedbackDisable;
    }

    handleFeedback(segment) {
        var dlg = this.refs['feedback-dlg'];
        if (dlg && segment) {
            dlg.open(segment);
        }
    }

    render() {
        const entitiesData = this.props.entitiesData;
        var self = this;
        let present_types =new Set(this.props.segments
            .filter((s)=>s.entities.length)
            .map((s)=>s.entities[0].type));
        const types_list = Array.from(present_types).map((t)=>({name: t, selected:true}));
        return(
            <div className="tagged-text-container" >
                <div className='tagged-text'>
                    {!this.feedbackDisable &&
                        <EntityFeedbackDialog text={this.props.text} results={this.props.json} ref="feedback-dlg"/>
                    }
                    <Legend types={types_list}/>
                    {/* <Legend types={this.props.types}/> */}

                    <table className="action-container">
                        <tbody>
                            <tr>
                                <td>
                                    <div className='confidence-container'>
                                        <ConfidenceFilter
                                            minConfidence = {this.props.minConfidence}
                                            onConfidenceFilterChange = {this.props.onConfidenceFilterChange}
                                            results = {this.props.results}
                                            segments={ this.props.segments } />  
                                    </div>
                                </td>
                                <td>
                                    <div className="toolbar-container">
                                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onReset}>
                                            <span className='fa fa-undo'></span>&nbsp;Reset
                                        </button>
                                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onEdit}>
                                            <span className='fa fa-edit'></span>&nbsp;Edit
                                        </button>
                                        {!this.feedbackDisable &&
                                            <div style={{marginRight:'15px'}}>
                                                <GeneralFeedbackDialog text={this.props.text} results={this.props.json}/>
                                            </div>
                                        }
                                        {'relationships' in this.props.json && this.props.json.relationships.length > 0 &&
                                            <div style={{marginRight:'15px'}}>
                                                <RelationshipsGraphDialog entitiesData={this.props.entitiesData} relationships={this.props.json.relationships}/>
                                            </div>
                                        }
                                        {'relationships' in this.props.json && this.props.json.relationships.length > 0 &&
                                            <div style={{marginRight:'15px'}}>
                                                <RelationshipsTable text={this.props.text} json={this.props.json} relationships={this.props.json.relationships}/>
                                            </div>
                                        }
                                        {'translatedText' in this.props.json &&
                                        <div style={{marginRight:'15px'}}>
                                            <TranslatedTextDialog 
                                                sourceText={this.props.originalText} 
                                                sourceLanguage={this.props.languageCode}
                                                targetText={this.props.json.translatedText}/>
                                        </div>
                                        }
                                    </div>                                   
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    {'documentSummary' in this.props.json &&
                        <div className="document-summary">
                            <div className="summary-label">Summary</div>
                            {'summary' in this.props.json.documentSummary ?
                                <div className="summary-text">{this.props.json.documentSummary.summary}</div>

                            :
                                'summarySentences' in this.props.json.documentSummary &&
                                    this.props.json.documentSummary.summarySentences.map((sentence, indx) => {
                                        return <span key={`doc-summary-sent-${indx}`} className="summary-sentence">
                                            {sentence}
                                        </span>
                                    })
                            }
                        </div>
                    }
                    <div>
                    {
                        this.props.segments.map(function(segment, idx) {
                            return <SegmentWithToolip 
                                        getEntityData = {(entityID)=> {
                                            if(entitiesData && entitiesData[entityID.toString()] !== undefined){
                                                return entitiesData[entityID];
                                            }
                                            return null;
                                        }}
                                        key={ idx } 
                                        segment={ segment } 
                                        handleFeedback={self.handleFeedback}/>;
                        })
                    }
                    </div>
                </div>
            </div>
        );
    }
};

SegmentsControl.propTypes = {
    onConfidenceFilterChange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    segments: PropTypes.array.isRequired,
    minConfidence: PropTypes.number.isRequired,
    results: PropTypes.array.isRequired,
    text: PropTypes.string.isRequired,
    originalText: PropTypes.string.isRequired,
    json: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array
    ]).isRequired,
    languageCode: PropTypes.string
};

export default SegmentsControl;

